import { useMemo } from 'react'
import React from 'react'

import { CommandGroup, CommandItem, CommandSeparator } from 'cmdk'
import { Check } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { Misc } from '@fortem-monorepo/web-sdk'

export interface ClientIdOptionsProps {
  clients?: Misc.GetTradeClientsData
  value?: number | string | null
  onSelect?: (strategy: Misc.GetTradeClientsData[number]) => void
}

export const ClientIdOptions: React.FC<ClientIdOptionsProps> = ({ clients, value, onSelect }) => {
  const strategyGroups = useMemo(() => {
    type Strategy = Misc.GetTradeClientsData[number]
    type StrategyGroups = Record<string, Strategy[]>

    const _groups: StrategyGroups = (clients ?? []).reduce((prev, current) => {
      const _new = { ...prev }

      if (!_new[current.scope]) {
        _new[current.scope] = [current]
      } else {
        _new[current.scope].push(current)
      }

      return _new
    }, {} as StrategyGroups)

    return _groups
  }, [clients])

  return (
    <>
      {Object.entries(strategyGroups)?.map(([label, clients], index) => {
        const isFirst = index === 0

        return (
          <React.Fragment key={index}>
            {!isFirst && <CommandSeparator />}
            <CommandGroup heading={label}>
              {clients
                ?.filter((c) => !!c.value)
                .map((client) => {
                  const { label, value: client_id } = client
                  const is_selected = client_id === value

                  return (
                    <CommandItem
                      value={client_id?.toString()}
                      onSelect={() => {
                        onSelect?.(client)
                      }}
                      disabled={is_selected}
                      key={client_id}
                    >
                      <div className={'flex items-center gap-2 justify-between w-full'}>
                        <span>{label}</span>
                        {is_selected && <Check className={cn('text-green-700 ml-auto h-4 w-4')} />}
                      </div>
                    </CommandItem>
                  )
                })}
            </CommandGroup>
          </React.Fragment>
        )
      })}
    </>
  )
}
